import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Button } from "@mui/material";

import bulbIcon from "../../../assets/images/bulb-light-icon.svg";
import alertIcon from "../../../assets/images/alert.png";
import IconButton from "@mui/material/IconButton";
import "../common/style.css";
import { useAppContext } from "../../../hooks/context/AppContext";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "40%", // Set width to 80% of the screen
    maxWidth: "none", // Remove the default maxWidth constraint
    minHeight: "250px",
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface UnSavedModalProps {
  close: () => void;
  saveUnSavedModal: () => void;
  draftSavedModal: () => void;
  discardModal: () => void;
  isDraftDisabled: boolean;
}

const InnoflexSaveModal: React.FC<UnSavedModalProps> = ({
  close,
  saveUnSavedModal,
  draftSavedModal,
  discardModal,
  isDraftDisabled,
}) => {
  const { appData } = useAppContext();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(appData.showUnSavedModal);
  }, [appData.showUnSavedModal]);

  // @ts-ignore
  const handleClose = () => {
    close();
  };
  return (
    <>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        className="modalSave"
      >
        <IconButton
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        ></IconButton>
        <DialogContent>
          <div className="save-card-wapper">
            <h3 className="modal-title">Save Form Alert</h3>
            <br></br>
            <hr></hr>
            <div className="alert-icon-wp">
              <img src={alertIcon} alt="" />
            </div>
            <h2 className="title-save-frm">You have not saved this form</h2>
            <div className="txt-flex--mt">
              <span className="bulb-txt">
                <img src={bulbIcon} alt="" />
              </span>
              {!isDraftDisabled ? (
                <p className="sv-txt-disc">
                  Your changes will only be saved after you click SUBMIT or
                  DRAFT. You can return to this form later if needed.
                </p>
              ) : (
                <p className="sv-txt-disc">
                  Your changes will only be saved after you click SUBMIT. You
                  can return to this form later if needed.
                </p>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: "20px !important" }}>
          <Button
            onClick={discardModal}
            sx={{
              backgroundColor: "#ff4d4f",
              borderRadius: "30px",
              color: "#fff",
              minWidth: "70px",
              width: "120px",
              mx: "15px !important",
            }}
          >
            Discard
          </Button>
          <Button
            onClick={handleClose}
            autoFocus
            sx={{
              backgroundColor: "#d9d9d9",
              borderRadius: "30px",
              color: "#535151",
              minWidth: "70px",
              width: "120px",
              mx: "15px !important",
            }}
          >
            Cancel
          </Button>
          {!isDraftDisabled && (
            <Button
              disabled={isDraftDisabled}
              onClick={draftSavedModal}
              sx={{
                backgroundColor: "#2a3fbf",
                borderRadius: "30px",
                color: "#fff",
                minWidth: "70px",
                width: "120px",
                mx: "15px !important",
                "&.Mui-disabled": {
                  backgroundColor: "#d9d9d9 !important",
                  color: "#5f6368 !important",
                },
              }}
            >
              Draft
            </Button>
          )}
          <Button
            onClick={saveUnSavedModal}
            sx={{
              backgroundColor: "#2a3fbf",
              borderRadius: "30px",
              color: "#fff",
              minWidth: "70px",
              width: "120px",
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
};

export default InnoflexSaveModal;
